module.exports = require("regenerator-runtime");



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/babel-runtime@6.26.0/~/babel-runtime/regenerator/index.js
// module id = 66
// module chunks = 0